/* eslint-disable import/no-unresolved */
import { ProposerDetails } from "src/redux/Reducers/proposerDetails/interface";
import * as types from "../../Types/proposerDetails";

export const setProposerDetails = (payload: ProposerDetails) => ({
  type: types.SET_PROPOSER_DETAILS,
  payload
});

export const saveProposerDetails = (proposerBinding: Record<string, any>, leadId: string) => ({
  type: types.SAVE_PROPOSER_DETAILS,
  payload: { proposerBinding, leadId }
});

export const setPincodeData = (payload: { city: string; state: string }) => ({
  type: types.POPULATE_PINOCODE_DATA,
  payload
});

export const setSubOccupationData = (payload: any) => ({
  type: types.SET_SUB_OCCUPATION_DATA,
  payload
});

export const setCountry = (payload: any) => ({
  type: types.SET_COUNTRY_DATA,
  payload
});

export const setProposerMasterData = (payload: Record<string, any>) => ({
  type: types.SET_PROPOSER_MASTER_DATA,
  payload
});

export const setProposerReviewData = (payload: Record<string, any>) => ({
  type: types.SET_PROPOSER_REVIEW_DATA,
  payload
});
